// @flow
import React, { Component } from "react";
import { Field } from "redux-form";
import type { FieldProps } from "redux-form";
import Checkbox from "@material-ui/core/Checkbox";
import { FormControlLabel } from "@material-ui/core";
import FormHelperText from "@material-ui/core/FormHelperText";

type Option = {
    label: string,
    value: string,
};
type CheckboxGroupType = {
    options: Array<Option>,
} & FieldProps;
export default class CheckboxGroup extends Component<CheckboxGroupType> {
    field = ({ input, meta, options }: CheckboxGroupType): Object => {
        const { name, onChange } = input;
        const { touched, error } = meta;
        const inputValue = input.value;

        const checkboxes = options.map(({ label, value }, index) => {
            const handleChange = event => {
                const arr = [...inputValue];
                if (event.target.checked) {
                    arr.push(value);
                } else {
                    arr.splice(arr.indexOf(value), 1);
                }
                return onChange(arr);
            };
            const checked = inputValue.includes(value);
            return (
                <FormControlLabel
                    key={`checkbox-${value}`}
                    label={label}
                    control={
                        <Checkbox
                            name={`${name}[${index}]`}
                            value={value}
                            checked={checked}
                            onChange={handleChange}
                            className="form__checkbox"
                        />
                    }
                />
            );
        });

        return (
            <div>
                <div>{checkboxes}</div>
                {touched && error && (
                    <FormHelperText className="error__message">
                        {error}
                    </FormHelperText>
                )}
            </div>
        );
    };

    render() {
        const {
            input: { name },
        } = this.props;
        return (
            <Field
                name={name}
                {...this.props}
                type="checkbox"
                component={this.field}
            />
        );
    }
}
